import qs from 'qs';
import { network } from 'services/network';

export const getComponent = ({ componentId }) => {
    const querystring = qs.stringify({ componentId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/reporting/getComponent${querystring}`;

    return network.post(url).then((response) => response.data);
};
